var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-icon-plus-circle-fill',{staticClass:"plus icon"}),_c('div',[_vm._v("Új feltétel hozzáadása")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }